<!-- eslint-disable vue/multi-word-component-names -->
<template>
	<div class="manifesto-page">
		<div v-for="(item, key) in content" :key="key">
			<p v-if="item.type === 'paragraph'" ref="text">
				{{ item.children[0].text }}
			</p>
		</div>
		<!-- <div class="moto-container">
			<img :src="moto" alt="" ref="moto">
		</div> -->
		<div class="lottie-container" ref="lottieContainer">
			<div class="lottie" ref="bodymovin">
			</div>
		</div>

	</div>
</template>
<script>
import axios from 'axios';
import store from '@/assets/js/store'
import GlobalEvents from '@/assets/js/utils/GlobalEvents'
import { E } from '@/assets/js/utils'
import moto from '@/assets/image/moto.png'
import SplitType from 'split-type'
import lottie from 'lottie-web'
import ScrollTrigger from 'gsap/ScrollTrigger'
import gsap from 'gsap'
import { useRoute } from 'vue-router'
gsap.registerPlugin(ScrollTrigger)
export default {
  name: 'Manifesto-comp',
  components: {},
  props: {
    data: Object
  },
  watch: {
	content(){
		if(store.isLoaded){
			this.addText()
			if(store.Lenis){
				setTimeout(() => {
					store.Lenis.dimensions.resize()
					ScrollTrigger.update()
					this.setScrollTrigger()
				}, 500)
			}
			if(!this.lottieDomLoaded){
				setTimeout(() => {
						ScrollTrigger.update()
						E.emit('domCanvasAdd',{el:this.anim.renderer.svgElement})
				}, 200)
			}

		}
		setTimeout(() => {
			// this.addImage()
			

		}, 500)
	}
  },
  data () {
    return {
		apiUrl: process.env.VUE_APP_API,
		content: [],
		moto: moto,
		lineCount: 0,
		lottieDomLoaded: false
	}
  },
  async created () {
	this.route =  useRoute();
	if(store[this.route.name]) {
		this.content = store[this.route.name]
	} else {
		try {
			const response = await axios.get(`${process.env.VUE_APP_API}/api/manifesto`)
			this.content = response.data.data.attributes.content
			store[this.route.name] = this.content
		} catch (error) {
			this.error = error;
		}
	}
  },
  mounted () {
	if(store.Lenis){
		store.Lenis.scrollTo(0, { immediate: true})
	}
	this.route =  useRoute();
	this.anim =  lottie.loadAnimation({
		container: this.$refs.bodymovin, // Required
		path:'../anim/forusbyus.json', // Required
		renderer: 'svg', // Required
		loop: false, // Optional
		autoplay: false, // Optional
		name: "forusbyus", // Name for future reference. Optional.
	})
	this.animListener = this.anim.addEventListener('drawnFrame', () => {
		E.emit('domSvgUpdate', this.anim.renderer.svgElement)
	})
	this.anim.addEventListener('DOMLoaded', () => {
		this.lottieDomLoaded = true
		setTimeout(() => {
			store.Lenis.dimensions.resize()
			ScrollTrigger.update()
			E.emit('domCanvasAdd',{el:this.anim.renderer.svgElement})
		}, 500)
		if(this.content.length > 0){
				setTimeout(() => {
					// store.Lenis.dimensions.resize()
					ScrollTrigger.update()
					this.setScrollTrigger()	
				}, 500)
		}
	})
	E.on(GlobalEvents.RESIZE, this.onResize)
	if(!store.isLoaded){
		E.on('LoaderOut',() => {
			if(window.urlParams.has('charlie')){
				store.MainScene.components.video.item.material.uniforms.uIsCharlie.value = 1
			}
			E.emit('introEnter', {page: this.route.name})
			this.addText()
			// E.emit('domCanvasAdd',{el:this.anim.renderer.svgElement})
			setTimeout(() => {
				E.emit('isPlainBackground', 1)
			}, 1)
		})
	} else {
		setTimeout(() => {
			E.emit('isPlainBackground', 1)
		}, 1)
	}
  },
  beforeUnmount(){
	// E.emit('domCanvasLeave', this.$refs.moto)
	this.lineCount = 0
	this.anim.stop()
	E.emit('domCanvasLeave',  this.anim.renderer.svgElement)
	this.anim.addEventListener('drawnFrame', this.animListener )
	if(this.scrollLottie)this.scrollLottie.kill()
	if(this.scrollLogo)this.scrollLogo.kill()
	this.$refs.text.forEach(el => {
		el.split.lines.forEach((el) => {
			E.emit('domCanvasLeave', el)
		})
	})
	lottie.destroy('forusbyus')
	E.emit('leaveManifesto')
  },
  methods: {
	addText() {
		if(!store.isLoaded){
			E.on('PageLoaded',() => {
			setTimeout(() => {
				this.$refs.text.forEach((el) => {
					el.split = new SplitType(el,{ types: 'lines' })
					el.split.lines.forEach((el) => {
						E.emit('domCanvasAdd', { el: el, opacity: 0, y: 100, x: 0, id: this.lineCount})
						this.lineCount++
					})
					
				})
			}, 10)
		})
		} else {
			this.$nextTick(() => {
				this.$refs.text.forEach((el) => {
					el.split = new SplitType(el,{ types: 'lines' })
					setTimeout(() => {
							el.split.lines.forEach((el) => {
							E.emit('domCanvasAdd', { el: el, opacity: 0, y: 100, x: 0, id: this.lineCount})
							this.lineCount++
						})
					}, 100)
				})
			})
		}
	},
	addImage(){
		E.emit('domCanvasAdd', { el: this.$refs.moto, opacity: 0, y: 0, x: 0})
	},
	setScrollTrigger(){
		// this.anim.play()
		this.scrollLottie =  ScrollTrigger.create({
			trigger:this.$refs.bodymovin,
			start: "top bottom",
			end: "bottom bottom",
			scrub: 1,
			onLeaveBack: () => {
				// this.anim.stop()
			},
			onLeave: () => {
				this.anim.play()
			}
		})

		this.scrollLogo =  ScrollTrigger.create({
			trigger:this.$refs.bodymovin,
			start: "center bottom",
			end: "center center",
			scrub: 1,
			onUpdate: function(e) {
				store.MainScene.components.logo.token1.position.y = -4.5 + (e.progress * 4.5)
			}
		})
		// this.scrollLottieExit =  ScrollTrigger.create({
		// 	trigger:this.$refs.bodymovin,
		// 	start: "top bottom",
		// 	end: "top center",
		// 	scrub: 1,
		// 	onLeaveBack: () => {
		// 		this.anim.stop()
		// 	}
		// })
	},
	onResize(){
		store.Lenis.scrollTo(0, { immediate: true})
		this.$refs.text.forEach((el, i) => {
			el.split.lines.forEach((el) => {
				E.emit('domCanvasRemove', el)
			})
			// el.split.split()
			el.split.lines.forEach((el, id) => {
				E.emit('domCanvasAdd', { el: el, opacity: 1, y: 0, x: 0, id: id + i})
			})
		})
	}
  }
}
</script>
<style lang="less">
@import '../../assets/less/_imports.less';
@import "./style.less";
</style>